import { stateful, useObservable } from '@adornis/functional-lit/stateful.js';
import { currentUser } from '@adornis/users/client/currentUser.js';
import { html, nothing } from 'lit';

type PublicFooterProps = { compactMobile?: boolean };

const PublicFooterContent = stateful((props: PublicFooterProps) => {
  const user = useObservable(() => currentUser(), []);
  return html`<footer
    class="mt-auto w-full shrink-0 border-t border-base-300 bg-base-100 ${props.compactMobile ? 'pb-[env(safe-area-inset-bottom)] md:pb-0' : ''}"
  >
    <div
      class="footer footer-center mx-auto grid-flow-row grid-cols-1 w-full max-w-7xl gap-2 px-4 text-sm sm:px-6 ${props.compactMobile ? 'py-0 md:py-2' : 'py-2'}"
    >
      ${user ? html`<p class="min-w-0 max-w-full break-all ${props.compactMobile ? 'hidden md:block' : ''}">Angemeldet als ${user.email}</p>` : nothing}
      <nav class="flex flex-wrap items-center justify-center gap-x-6 gap-y-2" aria-label="Rechtliche Informationen">
        <a
          class="link link-hover inline-flex items-center ${props.compactMobile ? 'min-h-8 md:min-h-11' : 'min-h-11'}"
          href="/impressum"
          target="_blank"
          rel="noopener"
          >Impressum</a
        >
        <a
          class="link link-hover inline-flex items-center ${props.compactMobile ? 'min-h-8 md:min-h-11' : 'min-h-11'}"
          href="/datenschutz"
          target="_blank"
          rel="noopener"
          >Datenschutz</a
        >
      </nav>
    </div>
  </footer>`;
});

export const PublicFooter = (props: PublicFooterProps = {}) => PublicFooterContent(props);
